import { MB_Modal } from '@mightybyte/rnw.components.modal';
import React from 'react';
import { StyleSheet, View, Text, ViewStyle, StyleProp, TextStyle } from 'react-native';
import { BarIndicator } from './react-native-indicators';

interface MB_ActivityIndicatorModalProps {
    /**
     * Controls whether the modal is visible or not.
     */
    isVisible: boolean,
    
    /**
     * A callback that is called when the modal is dismissed.
     */
    onDismiss: (isVisible: false) => void,
    
    /**
     * The style of the activity indicator's wrapper.
     */
    style?: StyleProp<ViewStyle>
    
    /**
     * The style of the activity indicator's text.
     */
    textStyle?: StyleProp<TextStyle>
    
    /**
     * @description The text to display.
     * 
     * @default "Loading..."
     */
    text?: string
    
    /**
     * @description A custom activity indicator to display.
     * 
     * @default <BarIndicator color='white' count={5} style={{ flex: undefined }} />
     */
    activityIndicator?: JSX.Element
}

const MB_ActivityIndicatorModal = ({
    isVisible,
    onDismiss,
    style = styles.wrapper,
    textStyle = styles.loadingText,
    text = 'Loading...',
    activityIndicator = <BarIndicator color='white' count={5} style={{ flex: undefined }} />,
}: MB_ActivityIndicatorModalProps) => {

    return (
        <MB_Modal
            isVisible={isVisible}
            onDismiss={onDismiss}
            simplified
            hideCloseButton
        >
            <View style={style}>
                {activityIndicator}
                <Text style={textStyle}>{text}</Text>
            </View>
        </MB_Modal>
    );
};

export { MB_ActivityIndicatorModal };
export type { MB_ActivityIndicatorModalProps };

const styles = StyleSheet.create({
    wrapper: {
        backgroundColor: '#1D1A31',
        width: 200,
        height: 200,
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
    loadingText: {
        fontSize: 20,
        color: 'white',
        textAlign: 'center',
        marginTop: 8,
    }
});
